import { render } from "./Configuraciones.vue?vue&type=template&id=5da71a7a&scoped=true"
import script from "./Configuraciones.vue?vue&type=script&lang=js"
export * from "./Configuraciones.vue?vue&type=script&lang=js"

import "./Configuraciones.vue?vue&type=style&index=0&id=5da71a7a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Usuario\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da71a7a"]])

export default __exports__